import {
  browserTracingIntegration,
  init,
  replayIntegration,
  withSentryRouting,
} from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { env } from "./env";
import "./index.css";
import App from "./app";
import { installOverscrollNoneFallback } from "./lib/utils/overscroll-none-fallback";

installOverscrollNoneFallback();

// Initialize Sentry as early as possible (skip in development)
if (import.meta.env.PROD) {
  init({
    dsn: env.VITE_SENTRY_DSN,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [browserTracingIntegration(), replayIntegration()],

    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      "localhost",
      env.VITE_BASE_URL,
      env.VITE_BETTER_AUTH_URL,
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

const SentryRoutes = import.meta.env.PROD
  ? withSentryRouting(BrowserRouter)
  : BrowserRouter;

// biome-ignore lint/style/noNonNullAssertion: False positive.
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <SentryRoutes>
      <App />
    </SentryRoutes>
  </StrictMode>,
);
